import { Component, OnInit, Output, EventEmitter } from '@angular/core';

/**
 * this is a generic component and not used as a separate web component.
 * It is used inside another components
 */
@Component({
  selector: 'jr-card-notification',
  templateUrl: './card-notification.component.html',
  styleUrls: []
})
export class CardNotificationComponent implements OnInit {
  @Output() cta = new EventEmitter<void>();

  constructor() { }

  ngOnInit() { }
}
